import React from 'react'
import PropTypes from 'prop-types'
import ProductList from '../ProductList/ProductList'
import { urlHelpers } from '../../helpers'

/**
* Wrapper component for ProductList component to display recommended products
* based on criteria specified in `data` prop. (Usually from Prismic).
*/
class DynamicProductList extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const count = this.props.data.count || 25
    let url; let listData; const
      emptyProducts = []

    // Determine API endpoint based on list type.
    if (this.props.data.recommendationType === 'previous-order' && __USER__.previousOrder) {
      url = `/api/recommendations/orders/${__USER__.previousOrder}`
    } else if (this.props.data.recommendationType === 'cart-contents' && __USER__.currentOrder) {
      url = `/api/recommendations/orders/${__USER__.currentOrder}`
    } else if (this.props.data.recommendationType === 'related-products' && this.props.data.sku) {
      url = `/api/recommendations/products/${this.props.data.sku}`
    } else if (this.props.data.recommendationType === 'taxon-preview' && this.props.data.taxonId) {
      url = `/api/prismic/product_lists/${this.props.data.taxonId}/taxon`
    } else if (this.props.data.recommendationType == 'author-taxon' && this.props.data.taxonId) {
      url = `/products.json?sort[recent]=true&filters[producers][]=${this.props.data.taxonId}&${this.props.data.taxonIdChildren}&per_page=10`
    } else {
      return false
    }

    url = urlHelpers.addParams(url, {
      index: this.props.data.indexType || 'user',
      size: count,
    })

    // Initialize the empty list of products to pass to the productlist.
    for (let i = 0; i < count; i++) {
      emptyProducts[i] = {}
    }
    listData = Object.assign({}, this.props.data, {
      products: emptyProducts,
      productURL: url,
    })

    return <ProductList data={listData} isDynamic />
  }
}

DynamicProductList.defaultProps = {
  data: {},
}

DynamicProductList.propTypes = {
  data: PropTypes.object,
}

export default DynamicProductList
